export default {"src":"/_next/static/media/MODG.afa53f3e.svg","height":18,"width":18};